import React, { useContext, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { PDFViewerContext } from './PDFViewerContext';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PDFViewer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = () => {
  const { pdfData, filename, isOpen, closePDF } = useContext(PDFViewerContext);
  const [numPages, setNumPages] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (pdfData) {
      const url = URL.createObjectURL(pdfData);
      setPdfUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [pdfData]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleDownload = () => {
    if (pdfData) {
      const url = URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const handleBackdropClick = e => {
    if (e.target.classList.contains('pdf-viewer-overlay')) {
      closePDF();
    }
  };

  if (!isOpen || !pdfData) return null;

  return (
    <div className="pdf-viewer-overlay" onClick={handleBackdropClick}>
      <div className="pdf-viewer-toolbar">
        <button className="pdf-viewer-btn" onClick={handleDownload} title="Télécharger">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
          </svg>
          <span>{filename}</span>
        </button>
        <button className="pdf-viewer-btn pdf-viewer-close" onClick={closePDF} title="Fermer">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      </div>
      <div className="pdf-viewer-content">
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} loading="">
          {Array.from(new Array(numPages), (_, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={800} loading="" />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default PDFViewer;
